<template>
    <div class="linepay_fail">
        <section class="chapternav-top">
            <div class="container">
                <div class="row">

                  <div class="linepay-fail-box">
                    <i class="far fa-7x fa-times-circle"></i><br>
                    <img src="img/parkit/line/linepay_logo.png" alt="" /><br>
                    <h3>付款失敗</h3>
                    <p class="text-muted">
                        {{ error }} <br>
                        {{ returnMessage }}
                    </p>
                  </div>

                </div>
                

            </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'LinePayFail',
  components: {
  },
  props: {
  },
  data() {
    return {
        errorCodeCollection: {
            "1101" : "買家不是 LINE Pay 會員",
            "1102" : "買方被停止交易",
            "1104" : "找不到商家",
            "1105" : "此商家無法使用 LINE Pay",
            "1106" : "標頭資訊錯誤",
            "1110" : "無法使用的信用卡",
            "1124" : "金額錯誤 (scale)",
            "1141" : "付款帳戶狀態錯誤",
            "1154" : "自動付款帳戶無法使用",
            "1172" : "已有同一訂單編號的交易紀錄",
            "1190" : "regKey 不存在",
            "1193" : "regKey 已過期",
            "1198" : "正在處理請求...",
            "1199" : "內部請求錯誤",
            "1280" : "信用卡付款時候發生了臨時錯誤",
            "1281" : "信用卡付款錯誤",
            "1282" : "信用卡授權錯誤",
            "1283" : "因疑似詐騙，拒絶付款",
            "1284" : "暫時無法以信用卡付款",
            "1285" : "信用卡資訊不完整",
            "1286" : "信用卡付款資訊不正確",
            "1287" : "信用卡已過期",
            "1288" : "信用卡的額度不足",
            "1289" : "超過信用卡付款金額上限",
            "1290" : "超過一次性付款的額度",
            "1291" : "此信用卡已被掛失",
            "1292" : "此信用卡已被停卡",
            "1293" : "信用卡驗證碼 (CVN) 無效",
            "1294" : "此信用卡已被列入黑名單",
            "1295" : "信用卡號無效",
            "1296" : "無效的金額",
            "1298" : "信用卡付款遭拒",
            "9000" : "內部錯誤"
        },
        error: "內部錯誤",
        returnMessage: ""
    }
  },
  mounted() {
      var self = this
      if (self.$route.query.errorCode) {
          self.error = self.errorCodeCollection[self.$route.query.errorCode]
      }

      if (self.$route.query.returnMessage) {
          self.returnMessage = self.$route.query.returnMessage
      }
  },
  destroyed() {
   
  },
  methods: {
  }
}
</script>